module.exports = __webpack_public_path__ + "static/media/sg-flag.c3963dec.png";